import { Close } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import i18next from "i18next";
import FieldTitle from "../FieldTitle";
import Label from "../Label";

const ItemValue = ({ label, value }) => {
	return (
		<div>
			<FieldTitle label={label} className="mt-3" />
			<div className={!value ? "fst-italic" : ""}>{value ?? i18next.t("no-data")}</div>
		</div>
	);
};

const CoordinateInfo = ({ sample, onClose, grouped }) => {
	if (!sample) return null;

	return (
		<div>
			<div className="d-flex gap-1 justify-content-between">
				<Label isTitle className="m-0" text={i18next.t("sample-details")} />
				<IconButton onClick={onClose} className="p-1">
					<Close
						sx={{
							fontSize: 20,
						}}
					/>
				</IconButton>
			</div>

			{(sample.location || sample.extraction?.location_name) && (
				<ItemValue
					label={i18next.t("location")}
					value={sample.location?.name || sample.extraction.location_name}
				/>
			)}
			{!grouped && (
				<>
					<ItemValue
						label={i18next.t("basins")}
						value={sample?.basins?.map(({ name }) => name).join(", ")}
					/>
					<ItemValue label={i18next.t("date")} value={sample.date} />
					<ItemValue label={i18next.t("gender")} value={sample.gender.name} />
					<ItemValue
						label={i18next.t("preloaded-sample")}
						value={i18next.t(sample.pre_loaded ? "yes" : "no")}
					/>
				</>
			)}
			{grouped && (
				<>
					<ItemValue label={i18next.t("basins")} value={sample?.basins?.map(({ name }) => name).join(", ")} />
					<ItemValue
						label={i18next.t("genders")}
						value={sample?.genders?.map(({ name }) => name).join(", ")}
					/>
				</>
			)}
			<ItemValue label={i18next.t("latitude")} value={sample.lat} />
			<ItemValue label={i18next.t("longitude")} value={sample.lng} />
			{!grouped && (
				<>
					{sample.meters > 0 && <ItemValue label={i18next.t("meters")} value={sample.meters} />}
					<ItemValue
						label={i18next.t("preparation-number")}
						value={sample?.preparation_numbers?.map((p) => p)?.join(", ")}
					/>
					{sample.aditional_info && (
						<ItemValue label={i18next.t("additional-information")} value={sample.aditional_info} />
					)}
				</>
			)}
			{grouped && <ItemValue label={i18next.t("samples-amount")} value={sample.total} />}
		</div>
	);
};

export default CoordinateInfo;
